import React, {
  useState,
  useContext,
  useCallback,
  SyntheticEvent,
  useEffect,
} from 'react'
import get from 'lodash/get'
import classNames from 'classnames'
import formatTime from 'lib/format-time'
import { digg } from 'lib/ugc-interact'
import { getLoginHref } from 'lib/get-login-href'
import { GlobalStoreContext } from 'Components/store'
import { ImageItem } from './imageList'
import Link from 'next/link'
import { ArticleCardContext, getType } from 'Components/ugc/article-card'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import Toast from 'Components/toast-messager'
import Comment from 'Components/comment/index'
import deletePost from 'lib/delete-post'
import { FeedContext } from 'Pages/car_fans_community/feed'
import { CollectButton } from 'Components/new/community-card/interact'
import fetch from 'lib/decorated-fetch'
import getUrl from 'lib/url'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import useLoginCheckCallback from 'Components/hooks/use-login-check-callback'
import useFetchCollected from 'Components/hooks/use-fetch-collected'
import { articleTypeDiggTypeMap } from 'Components/hooks/use-toggle-digg'
export interface IInteract {
  group_id: string
  ugcType: number
  behot_time: number
  comment_count: number
  digg_count: number
  user_digg: boolean
  isVideo?: boolean
  isQA?: boolean
  adopted?: boolean
  label_tag_list: {
    name: string
    image: ImageItem
    concern_id: number
  }[]
  question_info?: {
    send_award: string
    award_icon_url: string
  }
}

interface IProps {
  info: IInteract
  isKoubei?: boolean
  articleType?: number
}

const example =
  'https://sf6-ttcdn-tos.pstatp.com/obj/mosaic-legacy/9b13000123433ab45552'

const reply_icon = require('../../public/static/reply.png')
const thumb_up_icon = require('../../public/static/digg.png')
const thumb_up_active_icon = require('../../public/static/digged.png')

export default React.memo(({ info, isKoubei, articleType }: IProps) => {
  const {
    group_id,
    ugcType,
    behot_time,
    comment_count: commentCountFromInfo,
    digg_count,
    user_digg,
    isVideo,
    isQA,
    adopted,
    question_info,
    label_tag_list,
  } = info
  const { send_award, award_icon_url } = question_info || {}
  const { name: community_name, image, concern_id } = label_tag_list?.[0] || {}
  const { url: community_icon } = image || {}
  const { state: globalState } = useContext(GlobalStoreContext)
  const [userDigg, setUserDigg] = useState(user_digg)
  const [diggCount, setDiggCount] = useState(digg_count)
  const {
    inheritNewCard,
    author_id,
    video_id,
    updated_total_count: commentCountFromContext,
    type,
  } = useContext(ArticleCardContext)
  const { onDeletePost } = useContext(FeedContext)

  const [replying, setReplying] = useState(false)
  const onReplyClick = () => {
    sendTeaCommEvent('click_comment_detail_shrink_btn', {
      shrink_type: replying ? 'fold' : 'unfold',
      group_id,
    })
    setReplying(!replying)
  }
  const comment_count =
    commentCountFromContext !== undefined
      ? commentCountFromContext
      : commentCountFromInfo

  const doDigg = useLoginCheckCallback(
    () => {
      if (inheritNewCard) {
        sendTeaCommEvent(userDigg ? 'rt_unlike' : 'rt_like', {
          group_id,
          author_id,
        })
      }
      const DIGG_ACTION = 'digg'
      const CANCEL_ACTION = 'cancel_digg'

      // 如果是视频卡片类型，需要将点赞post请求中的'like_type'修改为'dogg_ugc_video'
      const like_type = articleType
        ? articleTypeDiggTypeMap[articleType] || 'digg_thread'
        : getType(type) === 'ugc_video'
          ? 'digg_ugc_video'
          : 'digg_thread'
      const action = userDigg ? CANCEL_ACTION : DIGG_ACTION
      const user_id = get(globalState, 'userData.user_id')
      if (!user_id) {
        Toast.show({
          text: '请先登录~', // 1
        })
        return
      }
      // 先假设点赞成功
      setUserDigg(action === DIGG_ACTION)
      setDiggCount(action === DIGG_ACTION ? diggCount + 1 : diggCount - 1)
      digg({
        user_id,
        group_id,
        action,
        like_type,
      }).catch((err) => {
        console.log(err)
        // 如果失败了，重置点赞状态
        setUserDigg(action !== DIGG_ACTION)
        setDiggCount(diggCount)
      })
    },
    {
      enter_method: 'like',
    }
  )

  const handleDiggClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    doDigg()
  }

  const handleDelete = useCallback(async (event: SyntheticEvent) => {
    event.preventDefault()
    event.nativeEvent.stopPropagation()
    const status = await deletePost({
      group_id,
      video_id,
    }).catch((e) => {
      // no-op
    })
    if (status === 'success') {
      Toast.show({
        text: '删除成功',
      })
      if (onDeletePost) {
        onDeletePost(group_id)
      }
    } else {
      Toast.show({
        text: '删除失败',
      })
    }
  }, [])

  const collected = useFetchCollected({ id: group_id })

  return (
    <>
      <div className="ugc-interact">
        {community_name && (
          <a
            // eslint-disable-next-line react/jsx-no-target-blank
            target="_blank"
            href={`/community/${concern_id}`}
          >
            <div
              className="community"
              onClick={() => {
                if (inheritNewCard) {
                  sendTeaCommEvent('click_motor_forum_label', {
                    motor_id: concern_id,
                    motor_name: community_name,
                  })
                }
              }}
            >
              <span
                className="community-icon"
                style={{ backgroundImage: `url("${community_icon}")` }}
              />
              <span className="community-name">{community_name}</span>
            </div>
          </a>
        )}
        <span className="time">{formatTime(behot_time * 1000)}</span>
        {String(author_id) === globalState?.userData?.user_id && (
          <span className="delete" onClick={handleDelete}>
            删除
          </span>
        )}
        {isQA ? (
          <React.Fragment>
            <span className="answer-count">
              {comment_count === 0 ? '暂无' : comment_count}回答
            </span>
            {adopted ? <span className="adopted">已解决</span> : null}
            {!adopted && send_award && (
              <span className="award">
                <span
                  className="award-icon"
                  style={{ backgroundImage: `url("${award_icon_url}")` }}
                />
                <span className="award-text">{send_award}</span>
              </span>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <span
              className="comment item"
              style={!inheritNewCard ? { visibility: 'hidden' } : {}}
              onClick={(e: React.MouseEvent) => {
                if (onReplyClick) {
                  e.preventDefault()
                  e.stopPropagation()
                  onReplyClick()
                }
              }}
            >
              {comment_count}
            </span>

            {ugcType !== 1 && (
              <span
                className={classNames('digg item', {
                  digged: userDigg,
                })}
                onClick={handleDiggClick}
              >
                {diggCount !== 0 ? `${diggCount}点赞` : '点赞'}
              </span>
            )}
          </React.Fragment>
        )}
        {isKoubei ? null : (
          <CollectButton
            id={group_id}
            collected={collected}
            className="tw-ml-32"
            renderText={(status) => (status ? '已收藏' : '收藏')}
            style={{ fontSize: 14 }}
          />
        )}
        <style jsx>
          {`
            .ugc-interact {
              height: 20px;
              display: flex;
              align-items: center;
            }
            .community {
              border-radius: 2px;
              background-color: #f2f4fa;
              display: inline-flex;
              align-items: center;
              height: 20px;
              padding: 1px 6px;
              margin-right: 8px;
              font-size: 12px;
            }

            .community-icon {
              width: 14px;
              height: 14px;
              margin-right: 2px;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }

            .cummunity-name {
              font-size: 12px;
              line-height: 18px;
              color: #1f2129;
            }

            .time {
              font-size: 14px;
              line-height: 20px;
              color: #606370;
            }
            .delete {
              color: #979aa8;
              margin-left: 24px;
              font-size: 14px;
              line-height: 20px;
              cursor: pointer;
            }
            .item {
              margin-left: auto;
              position: relative;
              cursor: pointer;
              font-size: 14px;
              line-height: 20px;
              padding-left: 8px;
            }
            .item::before {
              content: '';
              position: absolute;
              top: 0;
              left: -21px;
              width: 20px;
              height: 19px;
              background-size: cover;
            }
            .share:before {
              background-image: url('https://sf6-ttcdn-tos.pstatp.com/obj/mosaic-legacy/9b13000123433ab45552');
            }
            .comment:before {
              background-image: url('${reply_icon}');
            }
            .digg {
              margin-left: 69px;
            }

            .digg::before {
              background-image: url('${thumb_up_icon}');
            }
            .digg.digged::before {
              background-image: url('${thumb_up_active_icon}');
            }
            .answer-count {
              justify-self: flex-end;
              margin-left: auto;
              color: #606370;
            }
            .adopted {
              margin-left: 40px;
              position: relative;
              color: #00a860;
            }
            .award {
              margin-left: 40px;
              display: flex;
              align-items: center;
            }
            .award-icon {
              width: 20px;
              height: 20px;
              background-size: cover;
              background-position: center;
              margin-right: 8px;
            }
            .award-text {
              font-size: 14px;
              color: #1f2129;
              line-height: 20px;
            }
          `}
        </style>
      </div>
      {inheritNewCard && replying && (
        <div
          id="comment"
          className="reply"
          onClick={(eve) => {
            eve.stopPropagation()
            eve.preventDefault()
          }}
        >
          <Comment
            gid={group_id}
            author_id={author_id}
            count={6}
            type={2360 <= type && type <= 2369 ? 'koubei' : 'article'}
          />

          <style jsx>
            {`
              .reply {
                margin-top: 26px;
                width: 100%;
                border-radius: 2px;
                background-color: #f7f8fc;
                padding: 35px 16px 0 16px;
              }
            `}
          </style>
        </div>
      )}
    </>
  )
})
